export const items = [
  {
    id: 1,
    title: "Bread Omlette",
    category: "Breakfast",
    price: 40,
    img: "/images/breakfast-1.jpg",
    desc:
      "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quis, minus consequatur",
  },
  {
    id: 2,
    title: "Chicken Biriyani",
    category: "Lunch",
    price: 90,
    img: "/images/lunch-2.jpg",
    desc:
      "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quis, minusi",
  },
  {
    id: 3,
    title: "Strawberry Delight",
    category: "Juices",
    price: 60,
    img: "/images/drinks-1.jpg",
    desc:
      "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quis, minusi",
  },
  {
    id: 4,
    title: "Lassi",
    category: "Juices",
    price: 100,
    img: "/images/drinks-2.jpg",
    desc:
      "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quis, minusi",
  },
  {
    id: 5,
    title: "Pane Carasare",
    category: "Breakfast",
    price: 120,
    img: "/images/lunch-1.jpg",
    desc:
      "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quis, minusi",
  },
  {
    id: 6,
    title: "Summer Fighter",
    category: "Juices",
    price: 80,
    img: "/images/drinks-3.jpg",
    desc:
      "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quis, minusi",
  },
  {
    id: 7,
    title: "Muscle Builder Meal",
    category: "Lunch",
    price: 70,
    img: "/images/lunch-3.jpg",
    desc:
      "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quis, minusi",
  },
  {
    id: 8,
    title: "American Classic",
    category: "Lunch",
    price: 90,
    img: "/images/breakfast-4.jpg",
    desc:
      "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quis, minusi",
  },
  {
    id: 9,
    title: "Waffle",
    category: "Breakfast",
    price: 65,
    img: "/images/breakfast-2.jpg",
    desc:
      "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quis, minusi",
  },
  {
    id: 10,
    title: "Day Starter",
    category: "Breakfast",
    price: 65,
    img: "/images/breakfast-3.jpg",
    desc:
      "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quis, minusi",
  },
]

export const chefs = [
  {
    id: 1,
    name: "Kevin Malone",
    desc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente commodi adipisci possimus obcaecati vitae nam magnam quos dolorem fuga pariatur eveniet earum, esse voluptatem optio atque temporibus quaerat inventore ad.",
    img: "/images/kevin.jpg",
  },
  {
    id: 2,
    name: "Louis Hansel",
    desc:
      "quos dolorem fuga pariatur eveniet earum, esse voluptatem optio atque temporibus quaerat inventore ad. Lorem ipsum dolor sit amet consectetur adipisicing elit. Exercitationem neque optio expedita laudantium.",
    img: "/images/louis-hansel.jpg",
  },
  {
    id: 3,
    name: "Febrian Zak",
    desc:
      "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Eligendi corrupti fugit totam eveniet molestias, dignissimos ipsa quas numquam ab. Cum quidem quos corporis dignissimos deleniti laboriosam esse ab quibusdam facilis.",
    img: "/images/FebrianZakariah.jpg",
  },
]
